import React from 'react'
import PropTypes from 'prop-types'
import EligiblePeopleComp from 'components/global/molecules/EligiblePeople'

const EligiblePeople = ({ input, sendId, ...rest }) => (
  <EligiblePeopleComp
    {...rest}
    onChange={(data) => {
      const ids = data && data.archive_selected.map((sle) => sle[sendId])
      input.onChange(ids)
    }}
  />
)

EligiblePeople.propTypes = {
  input: PropTypes.shape(),
  sendId: PropTypes.string,
}

EligiblePeople.defaultProps = {
  sendId: 'id',
}

export default EligiblePeople
